// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "spa/" + chunkId + "." + {"32":"9641ab93","259":"fe25f6ec","466":"a03a39e7","788":"8748a708","836":"95213270","914":"0e885711","973":"e2c344ce"}[chunkId] + ".css";
};